export const getCategoryObj = (categories, targetSlug) => {
  return categories.find(category => category.slug === targetSlug)
}

export const getSubcategoryObj = (subcategories, targetSlug) => {
  return subcategories.find(subcategory => subcategory.slug === targetSlug)
}
